import { render, staticRenderFns } from "./choose_me_age.vue?vue&type=template&id=154228b6&scoped=true&"
import script from "./choose_me_age.vue?vue&type=script&lang=js&"
export * from "./choose_me_age.vue?vue&type=script&lang=js&"
import style0 from "./choose_me_age.vue?vue&type=style&index=0&id=154228b6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154228b6",
  null
  
)

export default component.exports